<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{ this.$route.meta.title }}</a>
      </div>
      <div class="collapse navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <drop-down tag="li" icon="ti-bell" class="header-notice">
            <li :class="'text-'+notification.type" v-for="notification in getRecentNotifications">{{ notification.message }}</li>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  data () {
    return {
      activeNotifications: false
    }
  },
  computed: mapGetters(['getRecentNotifications']),
  methods: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    },
    minimizeSidebar () {
      this.$sidebar.toggleMinimize()
    }
  }
}

</script>
<style>
.header-notice .dropdown-menu {
  min-width: 250px;
}

.header-notice .dropdown-menu li {
  padding: 5px 10px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue